import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-application',
  templateUrl: './warning-application.component.html',
  styleUrls: ['./warning-application.component.scss']
})
export class WarningApplicationComponent implements OnInit {
  title = '';
  errorMessage = '';
  showCancelButton = true;
  constructor(
    private dialogRef: MatDialogRef<WarningApplicationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data?.title;
    this.errorMessage = data?.message;
    if (data?.showCancelButton == false) this.showCancelButton = false;
  }
  public closeMe(status: any) {
    this.dialogRef.close({ data: status });
  }

  ngOnInit(): void {}
}
